import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "2 2 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 8,
		r: 3.25,
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M6.8475 19.25H17.1525C18.2944 19.25 19.174 18.2681 18.6408 17.2584C17.8563 15.7731 16.068 14 12 14C7.93201 14 6.14367 15.7731 5.35924 17.2584C4.82597 18.2681 5.70558 19.25 6.8475 19.25Z"
	})]
});
export default SvgUser;
